import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authenticationReducer from "../components/authentication/authenticationSlice";
import editPasswordReducer from "../components/main/eidit-password/editPasswordSlice";
import headerReducer from "../components/global/header/headerSlice";
import drawerReducer from "../components/main/home/drawer/drawerSlice";
import drawerInfoReducer from "../components/main/home/drawer/drawer-item/drawer-info/drawerInfoSlice";
import drawerShareReducer from "../components/main/home/drawer/drawer-item/drawer-share/drawerShareSlice";
import alternativeFileModalReducer from "../components/main/home/drawer/drawer-item/drawer-share/alternative-file-modal/alternativeFileModalSlice";
import linkFileModalReducer from "../components/global/link-file-modal/linkFileModalSlice";
import uploadFileReducer from "../components/main/home/upload-and-create/upload-file/uploadFileSlice";
import createFolderReducer from "../components/main/home/upload-and-create/create-folder/createFolderSlice";
import directoryReducer from "../components/main/home/directory/directorySlice";
import directoryItemsReducer from "../components/main/home/directory/directory-items/directoryItemsSlice";
import deleteModalReducer from "../components/global/delete-modal/deleteModalSlice";
import shareManagementReducer from "../components/main/share-management/shareManagementSlice";
import userManagementReducer from "../components/main/user-management/userManagementSlice";
import downloadReducer from "../components/download/downloadSlice";
import reportsReducer from "../components/main/reports/reportsSlice";
import subReportsModalReducer from "../components/global/sub-reports-modal/subReportsModalSlice";

export const store = configureStore({
  reducer: {
    authenticationState: authenticationReducer,
    editPasswordState: editPasswordReducer,
    headerState: headerReducer,
    drawerState: drawerReducer,
    drawerInfoState: drawerInfoReducer,
    drawerShareState: drawerShareReducer,
    alternativeFileModalState: alternativeFileModalReducer,
    linkFileModalState: linkFileModalReducer,
    uploadFileState: uploadFileReducer,
    createFolderState: createFolderReducer,
    directoryState: directoryReducer,
    directoryItemsState: directoryItemsReducer,
    deleteModalState: deleteModalReducer,
    shareManagementState: shareManagementReducer,
    userManagementState: userManagementReducer,
    downloadState: downloadReducer,
    reportsState: reportsReducer,
    subReportsModalState: subReportsModalReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
